module.exports = __webpack_public_path__ + "img/01.dc0b9aff.png";